import { localStorage } from 'dibs-browser-storage';

const VIEW_COUNT_LOCAL_STORAGE_KEY = 'TRADE_DESIGN_MANAGER_ONBOARDING_MODAL_VIEW_COUNT';

const getViewCount = () => localStorage.getItem(VIEW_COUNT_LOCAL_STORAGE_KEY) || 0;

export function hasSeenTradeDesignManagerOnboarding() {
    return getViewCount() > 0;
}

export function logTradeDesignManagerOnboardingView() {
    localStorage.setItem(VIEW_COUNT_LOCAL_STORAGE_KEY, getViewCount() + 1);
}
